import React from 'react';
import {Box, Typography} from '@mui/material';
import {useTranslate} from 'react-admin';
import {t} from '../themes/statamicTokens';

/* eslint-disable no-template-curly-in-string */
const VARIABLES = [
    {token: '${salutation}',  labelKey: 'Salutation'},
    {token: '${givenName}',   labelKey: 'First name'},
    {token: '${familyName}',  labelKey: 'Last name'},
    {token: '${email}',       labelKey: 'Email'},
    {token: '${phone}',       labelKey: 'Phone'},
    {token: '${addressInfo}', labelKey: 'Address'},
    {token: '${iban}',        labelKey: 'IBAN'},
    {token: '${childName}',   labelKey: 'Sponsored child'},
    {token: '${projectName}', labelKey: 'Project'},
    {token: '${stripeLink}',  labelKey: 'Stripe link'},
    {token: '${paypalLink}',  labelKey: 'PayPal link'},
    {token: '${paymentLink}', labelKey: 'Payment link (Stripe/PayPal)'},
];
/* eslint-enable no-template-curly-in-string */

const MailVariablesLegend = () => {
    const translate = useTranslate();
    const copy = (token) => {
        if (navigator.clipboard) navigator.clipboard.writeText(token).catch(() => {});
    };

    return (
        <Box>
            <Typography sx={{fontSize: `${t.type.caption.size}px`, color: t.color.text.secondary, mb: 1}}>
                {translate('Optional fields to use in your templates. Click to copy.')}
            </Typography>
            <Box sx={{display: 'flex', flexDirection: 'column', gap: 0.5}}>
                {VARIABLES.map(v => (
                    <Box
                        key={v.token}
                        onClick={() => copy(v.token)}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            gap: 1.5,
                            py: 0.5,
                            px: 0.75,
                            borderRadius: `${t.radius.sm}px`,
                            cursor: 'pointer',
                            '&:hover': {backgroundColor: t.color.sidebarHover},
                        }}
                        title={translate('Click to copy')}
                    >
                        <Typography sx={{fontSize: `${t.type.caption.size}px`, color: t.color.text.secondary}}>
                            {translate(v.labelKey)}
                        </Typography>
                        <Box
                            component="code"
                            sx={{
                                fontFamily: t.font.mono,
                                fontSize: 11,
                                color: t.color.accent.primary,
                                backgroundColor: t.color.chip.monoBg,
                                border: `1px solid ${t.color.border.hairline}`,
                                borderRadius: `${t.radius.sm}px`,
                                px: 0.75,
                                py: 0.125,
                            }}
                        >
                            {v.token}
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default MailVariablesLegend;
